import { transformDTODate } from "@skylab-shared/core";
import { Transform, Type } from "class-transformer";
import { DdkState } from "../../accountancy/ddk-state";
import { JpkVatState } from "../../accountancy/jpk-vat-state";
import { EppState } from "../../common/epp-state";
import { VatReleaseReasonSource } from "../../company/vat-release-reason-source";
import { DocumentBuyerDTO, DocumentClientDTO } from "../../document/dto/document-client.dto";
import { DocumentVatTableDTO } from "../../document/dto/document-vat-table.dto";
import { FiscalizationState } from "../../fiscal/fiscal-state";
import { InventoryEffect } from "../../inventory/inventory-effect";
import { KsefDocumentStatus } from "../../ksef/ksef-document-status";
import { KsefProcessingStage } from "../../ksef/ksef-processing-stage";
import { KsefSessionState } from "../../ksef/ksef-session-state";
import { PaymentStatus } from "../../payment/payment-status";
import { AdvanceState } from "../advance-state";
import { OrderState } from "../sale-order-state";
import { SaleDocumentGetItemDTO } from "./sale-document-item.dto";
import { SaleDocumentDTO } from "./sale-document.dto";

export class SaleGetDocumentDTO extends SaleDocumentDTO {
	public adjustedDocumentId?: number;
	public adjustmentReasonId?: number;
	public advanceState?: AdvanceState;
	public ddkState: DdkState;
	public eppState: EppState;
	public fiscalizationState: FiscalizationState;
	public jpk_vatState: JpkVatState;
	public marginSchemeId: number;
	public numberingId: number;
	@Type(() => DocumentBuyerDTO) public otherSeller: DocumentBuyerDTO;
	public orderState: OrderState;
	@Type(() => DocumentClientDTO) public seller: DocumentClientDTO;
	public totalGrossValue: number;
	public totalNetValue: number;
	public totalGrossPlnValue: number;
	public totalNetPlnValue: number;
	public leftToPay?: number;
	public paymentState: PaymentStatus;
	@Type(() => DocumentVatTableDTO) public vatTable: DocumentVatTableDTO;
	public vatReleaseReasonId?: number;
	public vatReleaseReasonCustomName: string;
	public customDueDateDescription: string;
	public ksefProcessingStage: KsefProcessingStage;
	@Type(() => SaleDocumentGetItemDTO) public items: SaleDocumentGetItemDTO[];
	public ksefDocumentId?: string;
	public ksefCollectiveIdentifier?: string | null;
	public vatReleaseReasonSource: VatReleaseReasonSource;
	public includesInventoryControl: boolean;
	public ksefSessionReferenceNumber: string;
	@Transform(transformDTODate, { toClassOnly: true }) public ksefAcquisitionDateTime?: Date;
	@Transform(transformDTODate, { toClassOnly: true }) public ksefLastStatusCheckDate: Date;
	@Transform(transformDTODate, { toClassOnly: true }) public ksefIssueDate: Date;
	@Transform(transformDTODate, { toClassOnly: true }) public ksefLastReceivingUpoDate: Date;
	@Transform(transformDTODate, { toClassOnly: true }) public ksefSessionEndDate?: Date;
	public ksefAllDocumentsProcessed: boolean;
	public ksefSessionState?: KsefSessionState;
	@Transform(transformDTODate, { toClassOnly: true }) public ksefInitializationDate?: Date;
	public inventoryEffect: InventoryEffect;
	public ksefDocumentStatus?: KsefDocumentStatus;
    public ksefHash?: string;
	public ksefXmlExported: boolean | null;
	public ksefXmlImported: boolean | null;
	public ksefXmlUrl: string | null;
	@Transform(transformDTODate, { toClassOnly: true }) public ksefUpoDownloadUrlExpirationDate: Date;
    public ksefUpoDownloadUrl?: string;
    public ksefCertificateUrl?: string;
	public adjustPaymentDate: boolean;
}
